var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadphoneBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5091 14.9015C2.66617 14.8619 2.83063 14.8408 3 14.8408C4.10457 14.8408 5 15.7362 5 16.8408V18.8408C5 19.9454 4.10457 20.8408 3 20.8408C1.89543 20.8408 1 19.9454 1 18.8408V16.8408C1 15.9056 1.64187 15.1203 2.5091 14.9015ZM2.5091 14.9015L2.39658 14.1514C1.61838 8.9633 5.10139 4.09509 10.2629 3.15664C11.4115 2.94779 12.5885 2.94779 13.7371 3.15664C18.8986 4.09509 22.3816 8.9633 21.6034 14.1514L21.4909 14.9015M21.4909 14.9015C21.3338 14.8619 21.1694 14.8408 21 14.8408C19.8954 14.8408 19 15.7362 19 16.8408V18.8408C19 19.9454 19.8954 20.8408 21 20.8408C22.1046 20.8408 23 19.9454 23 18.8408V16.8408C23 15.9056 22.3581 15.1203 21.4909 14.9015Z",
    stroke: "#585858",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphoneBlack);
export default __webpack_public_path__ + "static/media/Headphone Black.532a28d734e0b63dc15cd8eb33948e4e.svg";
export { ForwardRef as ReactComponent };